class Redirect {
  constructor() {
    this.init();
  }

  init() {
    (function() {
      var url = location.href;
      if (url.endsWith('stories/') || url.endsWith('stories')) {
        location.replace('01/');
      }
    })();    
  }
}

export default Redirect